var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-file-chooser"
    },
    [
      _c(
        "span",
        {
          directives: [
            {
              name: "translate",
              rawName: "v-translate"
            }
          ]
        },
        [_vm._v("Ordner-Filter")]
      ),
      _vm._v(" "),
      _c("courseware-folder-chooser", {
        attrs: {
          allowUserFolders: "",
          unchoose: ""
        },
        model: {
          value: _vm.selectedFolderId,
          callback: function callback($$v) {
            _vm.selectedFolderId = $$v
          },
          expression: "selectedFolderId"
        }
      }),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "translate",
              rawName: "v-translate"
            }
          ]
        },
        [_vm._v("Datei")]
      ),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.currentValue,
              expression: "currentValue"
            }
          ],
          on: {
            change: [
              function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.currentValue = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
              _vm.selectFile
            ]
          }
        },
        [
          _c(
            "option",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.canBeEmpty,
                  expression: "canBeEmpty"
                }
              ],
              attrs: {
                value: ""
              }
            },
            [_c("translate", [_vm._v("Keine Auswahl")])],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.files, function(file, index) {
            return _c(
              "option",
              {
                key: index,
                domProps: {
                  value: file.id
                }
              },
              [_vm._v("\n            " + _vm._s(file.name) + "\n        ")]
            )
          }),
          _vm._v(" "),
          _c(
            "option",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.files.length === 0,
                  expression: "files.length === 0"
                }
              ],
              attrs: {
                disabled: ""
              }
            },
            [_c("translate", [_vm._v("Keine Dateien vorhanden")])],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }